import type { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

let browserAgent: BrowserAgent | undefined;

/**
 * The constructed Browser agent instance, or `undefined` if unavailable.
 * Kept in its own side-effect-free module (type-only import) so reading it never pulls in the real
 * @newrelic/browser-agent package, which throws outside a browser global.
 */
export const getNewRelicBrowserAgent = (): BrowserAgent | undefined => browserAgent;

/** Only initNewRelicBrowserAgent.ts should call this. */
export const setNewRelicBrowserAgent = (agent: BrowserAgent): void => {
    browserAgent = agent;
};
